export const ERROR_MESSAGES = {
  USER_NOT_FOUND: 'El usuario no existe.',
  INVALID_PASSWORD: 'Contraseña incorrecta.',
  UNAUTHORIZED: 'Acceso no autorizado.',
  SERVER_ERROR: 'Error en el servidor. Intentalo más tarde.',
  // Agregá más códigos según tu backend
};
